{
  "action": {
    "save": "保存",
    "saveChanges": "保存する",
    "openSidebar": "サイドバーを開く",
    "closeSidebar": "サイドバーを閉じる",
    "cancel": "キャンセル",
    "edit": "編集する",
    "submit": "更新する",
    "create": "作成する",
    "delete": "削除",
    "close": "閉じる",
    "settings": "設定",
    "signOut": "サインアウト",
    "signIn": "ログイン",
    "addSprint": "Sprint を追加",
    "addStory": "Story を追加",
    "addTask": "Task を追加",
    "backToBacklogs": "Backlogs へ戻る",
    "comment": "コメントする",
    "selectGroup": "グループの選択",
    "addGroup": "グループの追加",
    "addCategory": "カテゴリの追加",
    "addStatus": "ステータスの追加",
    "viewKanban": "Kanban を表示",
    "editSprint": "Sprint を編集",
    "closeSprint": "Sprint を閉じる",
    "openSprint": "Sprint をリオープンする",
    "upload": "アップロード",
    "browse": "参照",
    "actions": "操作",
    "copyToClipboard": "コピー",
    "copiedToClipboard": "クリップボードにコピーしました",
    "cannotCopiedToClipboard": "クリップボードにコピーできませんでした"
  },
  "title": {
    "relatedTasks": "関連するタスク",
    "story": "ストーリー",
    "newStory": "新規ストーリー",
    "newTask": "新規タスク",
    "masterBacklogs": "マスターバックログ",
    "productBacklogs": "プロダクトバックログ",
    "layout": "レイアウト",
    "default": "デフォルト",
    "horizontal": "水平",
    "task": "タスク",
    "tag": "タグ",
    "unassigned": "未アサイン",
    "search": "キーワード検索",
    "is_public": "公開",
    "progress": "進捗 (完了 / 合計)",
    "totalStoryPoints": "ストーリーポイント合計",
    "points": "ポイント",
    "backlogs": "バックログ",
    "kanban": "カンバン",
    "openingSprints": "進行中の Sprint",
    "closedSprints": "クローズされた Sprint"
  },
  "ticket": {
    "title": "タイトル",
    "titlePlaceholder": "タイトルを入力",
    "createdBy": "作成者",
    "lastUpdatedBy": "最終更新者",
    "category": "カテゴリ",
    "assignee": "担当者",
    "status": "ステータス",
    "point": "ポイント",
    "sprint": "Sprint",
    "sort_order": "Sort Order",
    "body": "説明文",
    "updatedBy": "更新者",
    "updatedAt": "更新日"
  },
  "category": {
    "title": "タイトル",
    "sortOrder": "表示順",
    "sort_order": "表示順",
    "color": "カラー"
  },
  "status": {
    "title": "タイトル",
    "sortOrder": "表示順",
    "sort_order": "表示順",
    "isDone": "完了ステータスとするか",
    "is_done": "完了ステータスとするか"
  },
  "settings": {
    "settings": "設定",
    "userSettings": "ユーザー設定",
    "generalSettings": "一般設定",
    "groupManagements": "グループ管理",
    "ticketCategories": "カテゴリ管理",
    "ticketStatuses": "ステータス管理",
    "theme": {
      "default": "デフォルト (shadcn)"
    },
    "general": {
      "title": "プロジェクトのタイトル",
      "description": "プロジェクトの説明",
      "isPublic": "公開プロジェクト",
      "ticketPrefix": "チケットプレフィックス",
      "projectImage": "プロジェクトのイメージ画像",
      "currentImage": "現在のイメージ"
    }
  },
  "message": {
    "noPeriodSpecified": "期間指定なし",
    "noSprintsYet": "Sprint がありません。",
    "noStoriesInBacklog": "バックログに Story がありません。",
    "noStoriesInThisSprint": "この Sprint に Story がありません。",
    "noClosedSprints": "クローズされた Sprint はありません。",
    "noStories": "Story がありません。",
    "failedToMoveStory": "Story の移動に失敗しました。",
    "failedToCreateSprint": "Sprint の作成に失敗しました。",
    "failedToUpdateSprint": "Sprint の更新に失敗しました。",
    "failedToCloseSprint": "Sprint のクローズに失敗しました。",
    "failedToOpenSprint": "Sprint のリオープンに失敗しました。",
    "failedToUpdateStory": "Story の更新に失敗しました。",
    "failedToMoveTask": "タスクの移動に失敗しました。",
    "failedToUpdateProjectSettings": "プロジェクト設定の更新に失敗しました。",
    "failedToUploadImage": "画像のアップロードに失敗しました。",
    "failedToDeleteImage": "画像の削除に失敗しました。",
    "noStatusesYet": "ステータスがありません。",
    "failedToCreateStatus": "ステータスの作成に失敗しました。",
    "failedToUpdateStatus": "ステータスの更新に失敗しました。",
    "failedToDeleteStatus": "ステータスの削除に失敗しました。",
    "noCategoriesYet": "カテゴリがありません。",
    "failedToCreateCategory": "カテゴリの作成に失敗しました。",
    "failedToUpdateCategory": "カテゴリの更新に失敗しました。",
    "failedToDeleteCategory": "カテゴリの削除に失敗しました。",
    "noGroupsAddedYet": "グループが追加されていません。",
    "noGroupsFound": "グループが見つかりません。",
    "failedToAddGroup": "グループの追加に失敗しました。",
    "failedToRemoveGroup": "グループの削除に失敗しました。",
    "failedToCreate": "作成に失敗しました。",
    "failedToUpdate": "更新に失敗しました。",
    "failedToDelete": "削除に失敗しました。",
    "failedToAddComment": "コメントの追加に失敗しました。",
    "failedToDeleteComment": "コメントの削除に失敗しました。",
    "failedToUpdatePoint": "ポイントの更新に失敗しました。",
    "areYouSure": "よろしいですか？",
    "withStory": "ストーリーと一緒に",
    "leaveAComment": "コメントを入力",
    "leaveADescription": "説明文を入力（Markdown 記法が使えます）",
    "noDescription": "説明文なし",
    "confirmDiscardChanges": "編集中の内容が失われますが、よろしいですか？",
    "groups": "グループ",
    "chooseAFile": "ファイルを選択 ...",
    "updateProjectSettingsSuccess": "プロジェクト設定を更新しました",
    "closedSprintDoesNotExists": "クローズされた Sprint はありません",
    "sprintDoesNotExists": "Sprint がありません。右側のプロダクトバックログにある「Sprint を追加」ボタンで Sprint を作成してみましょう。",
    "storyDoesNotExists": "Story がありません。「Story を追加」ボタンで Story を作成してみましょう。",
    "storyDoesNotExistsInSprint": "Story がありません。Backlogs に追加した Story を D&D で Sprint に追加してみましょう",
    "dropHere": "ここにドロップ",
    "historyIsEmpty": "更新履歴はありません",
    "tagInput": "タグを入力してください",
    "publicProject": "これは公開プロジェクトです。メンバーではないユーザはチケットへのコメントのみ許可されています。",
    "addGroup": "プロジェクトに追加したいグループ名を数文字入力してください。ユーザを追加したい場合にはユーザ名を入力してください。"
  },
  "sync": {
    "unavailable": "同期不可",
    "unavailableTooltip": "リアルタイム同期が無効です。ページを再読み込みしてください。",
    "reconnecting": "再接続中...",
    "reconnectingTooltip": "接続が切断されました。再接続中...",
    "justNow": "たった今",
    "secondsAgo": "{{count}} 秒前",
    "minuteAgo": "1 分前",
    "minutesAgo": "{{count}} 分前",
    "hourAgo": "1 時間前",
    "hoursAgo": "{{count}} 時間前"
  },
  "tab": {
    "comment": "コメント",
    "history": "更新履歴"
  }
}
